import React from "react";
import { Box, Button, Chip } from "@mui/material";
import {
  SOURCE_TYPE_OPTIONS,
  VOD_TYPE_OPTIONS,
  VODFilters,
} from "./vodListParams";

interface VODActiveFiltersProps {
  search: string;
  filters: VODFilters;
  onSearchChange: (search: string) => void;
  onFiltersChange: (filters: VODFilters) => void;
  onClearAll: () => void;
}

const VODActiveFilters: React.FC<VODActiveFiltersProps> = ({
  search,
  filters,
  onSearchChange,
  onFiltersChange,
  onClearAll,
}) => {
  if (!search && filters.type.length === 0 && filters.sourceType.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
        pb: 2,
      }}
    >
      {search && (
        <Chip
          size="small"
          label={`Search: ${search}`}
          onDelete={() => onSearchChange("")}
        />
      )}
      {VOD_TYPE_OPTIONS.filter((o) => filters.type.includes(o.value)).map(
        ({ value, label }) => (
          <Chip
            key={`type-${value}`}
            size="small"
            label={`Type: ${label}`}
            onDelete={() =>
              onFiltersChange({
                ...filters,
                type: filters.type.filter((t) => t !== value),
              })
            }
          />
        )
      )}
      {SOURCE_TYPE_OPTIONS.filter((o) =>
        filters.sourceType.includes(o.value)
      ).map(({ value, label }) => (
        <Chip
          key={`source-${value}`}
          size="small"
          label={`Source: ${label}`}
          onDelete={() =>
            onFiltersChange({
              ...filters,
              sourceType: filters.sourceType.filter((s) => s !== value),
            })
          }
        />
      ))}
      <Button size="small" variant="text" onClick={onClearAll}>
        Clear all
      </Button>
    </Box>
  );
};

export default VODActiveFilters;
